import { render, staticRenderFns } from "./goodsDetails.vue?vue&type=template&id=3575b19a&scoped=true&"
import script from "./goodsDetails.vue?vue&type=script&lang=js&"
export * from "./goodsDetails.vue?vue&type=script&lang=js&"
import style0 from "./goodsDetails.vue?vue&type=style&index=0&id=3575b19a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3575b19a",
  null
  
)

export default component.exports